/* Techno Express - Variant guard (11 oct 2026)
   Bloquea agregar al carrito variantes placeholder "Choose an option" (sin amperaje / Trip Rating)
   y bloquea el checkout si el carrito ya tiene alguna. No modifica productos ni precios. */
(function () {
  'use strict';
  if (window.__teVariantGuard) return;
  window.__teVariantGuard = true;

  var MSG = 'Please choose a Trip Rating (amperage) before adding this switch to your cart.';
  var CART_MSG = 'Some switches in your cart do not have a Trip Rating (amperage) selected. Remove them and add them again choosing the amperage:';
  var nativeFetch = window.fetch.bind(window);
  var cache = {};

  function isPlaceholder(text) {
    return /choose an option/i.test(String(text || ''));
  }

  function lookupInPage(id) {
    var found = null;
    var scripts = document.querySelectorAll('script[type="application/json"], script[type="application/ld+json"]');
    for (var i = 0; i < scripts.length && found === null; i++) {
      var txt = scripts[i].textContent || '';
      if (txt.indexOf(id) === -1) continue;
      try {
        var data = JSON.parse(txt);
        var list = Array.isArray(data) ? data : (data.variants || (data.product && data.product.variants) || []);
        for (var k = 0; k < list.length; k++) {
          if (String(list[k].id) === id) { found = list[k].title || list[k].public_title || ''; break; }
        }
      } catch (e) { /* ignore */ }
    }
    return found;
  }

  function titleFor(rawId) {
    var id = String(rawId);
    if (cache[id] !== undefined) return cache[id];
    var inPage = lookupInPage(id);
    if (inPage !== null) cache[id] = inPage;
    return inPage; /* null = desconocido */
  }

  function extractIds(body) {
    var ids = [];
    try {
      if (typeof FormData !== 'undefined' && body instanceof FormData) {
        if (body.get('id')) ids.push(body.get('id'));
        body.forEach(function (val, key) { if (/^items\[\d+\]\[id\]$/.test(key)) ids.push(val); });
      } else if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
        if (body.get('id')) ids.push(body.get('id'));
      } else if (typeof body === 'string') {
        try {
          var j = JSON.parse(body);
          if (j.id) ids.push(j.id);
          (j.items || []).forEach(function (it) { if (it && it.id) ids.push(it.id); });
        } catch (e) {
          var p = new URLSearchParams(body);
          if (p.get('id')) ids.push(p.get('id'));
        }
      }
    } catch (e) { /* ignore */ }
    return ids;
  }

  function blockedResponse() {
    return new Response(JSON.stringify({ status: 422, message: 'Trip Rating required', description: MSG }), {
      status: 422,
      headers: { 'Content-Type': 'application/json' }
    });
  }

  /* 1. Freno al agregar al carrito (tarjetas, PDP, quick add, recomendados) */
  function removePlaceholdersFrom(json) {
    var items = (json && (json.items || (json.variant_title !== undefined ? [json] : []))) || [];
    var bad = items.filter(function (it) { return isPlaceholder(it.variant_title); });
    if (!bad.length) return Promise.resolve(false);
    return bad.reduce(function (p, it) {
      return p.then(function () {
        return nativeFetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: it.key, quantity: 0 })
        }).catch(function () {});
      });
    }, Promise.resolve()).then(function () { return true; });
  }

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var isAdd = /\/cart\/add(\.js)?(\?|$)/.test(url);
    var isCartChange = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url);
    if (isAdd && init && init.body) {
      var ids = extractIds(init.body);
      if (ids.length) {
        var titles = ids.map(titleFor);
        if (titles.some(function (t) { return t !== null && isPlaceholder(t); })) {
          return Promise.resolve(blockedResponse());
        }
        if (titles.some(function (t) { return t === null; })) {
          /* Variante desconocida en la pagina: se revisa la respuesta del carrito */
          return nativeFetch(input, init).then(function (res) {
            return res.clone().json().then(function (json) {
              return removePlaceholdersFrom(json).then(function (removed) {
                scheduleCartCheck();
                return removed ? blockedResponse() : res;
              });
            }, function () { scheduleCartCheck(); return res; });
          });
        }
      }
    }
    var result = nativeFetch(input, init);
    if (isCartChange) result.then(scheduleCartCheck, function () {});
    return result;
  };

  /* Formularios sin AJAX: se frena solo si la variante se conoce en la pagina */
  document.addEventListener('submit', function (evt) {
    var form = evt.target;
    if (!form || !form.action || !/\/cart\/add/.test(form.action)) return;
    var input = form.querySelector('[name="id"]');
    if (!input || !input.value) return;
    var t = titleFor(String(input.value));
    if (t !== null && isPlaceholder(t)) {
      evt.preventDefault();
      evt.stopImmediatePropagation();
      window.alert(MSG);
    }
  }, true);

  /* 2. Red de seguridad en el carrito: bloquea checkout si hay placeholders */
  var badItems = [];
  var timer = null;
  function scheduleCartCheck() { clearTimeout(timer); timer = setTimeout(checkCart, 700); }

  function checkoutButtons() {
    return document.querySelectorAll('[name="checkout"], a[href^="/checkout"], a[href*="/checkouts/"], .shopify-payment-button, [data-shopify="dynamic-checkout-cart"], .additional-checkout-buttons');
  }

  function renderBanner() {
    var old = document.querySelectorAll('.te-variant-guard-banner');
    old.forEach(function (n) { n.remove(); });
    var buttons = checkoutButtons();
    buttons.forEach(function (b) {
      if (badItems.length) {
        b.setAttribute('data-te-blocked', '1');
        b.style.opacity = '0.45';
        b.style.pointerEvents = 'none';
        if ('disabled' in b) b.disabled = true;
      } else if (b.getAttribute('data-te-blocked')) {
        b.removeAttribute('data-te-blocked');
        b.style.opacity = '';
        b.style.pointerEvents = '';
        if ('disabled' in b) b.disabled = false;
      }
    });
    if (!badItems.length || !buttons.length) return;
    var seen = [];
    buttons.forEach(function (b) {
      var holder = b.parentElement;
      if (!holder || seen.indexOf(holder) !== -1) return;
      seen.push(holder);
      var box = document.createElement('div');
      box.className = 'te-variant-guard-banner';
      box.setAttribute('role', 'alert');
      box.style.cssText = 'background:#FDECEC;border:1px solid #E5484D;color:#7A1C1F;padding:10px 12px;border-radius:6px;margin:0 0 10px;font-size:14px;line-height:1.4;text-align:left';
      var html = '<strong>' + CART_MSG + '</strong><ul style="margin:6px 0 0 18px;padding:0">';
      badItems.forEach(function (it) {
        html += '<li><a href="' + (it.url || '#').replace(/"/g, '') + '" style="color:inherit;text-decoration:underline">' +
          String(it.product_title || it.title || '').replace(/</g, '&lt;') + '</a></li>';
      });
      box.innerHTML = html + '</ul>';
      holder.insertBefore(box, b);
    });
  }

  function checkCart() {
    nativeFetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        badItems = (cart.items || []).filter(function (it) {
          if (isPlaceholder(it.variant_title)) return true;
          return (it.options_with_values || []).some(function (o) { return isPlaceholder(o.value); });
        });
        renderBanner();
      })
      .catch(function () { /* ignore */ });
  }

  document.addEventListener('click', function (evt) {
    if (!badItems.length) return;
    var btn = evt.target.closest && evt.target.closest('[name="checkout"], a[href^="/checkout"], a[href*="/checkouts/"]');
    if (!btn) return;
    evt.preventDefault();
    evt.stopImmediatePropagation();
    var banner = document.querySelector('.te-variant-guard-banner');
    if (banner) banner.scrollIntoView({ behavior: 'smooth', block: 'center' });
    else window.alert(CART_MSG);
  }, true);

  ['cart:change', 'cart:refresh', 'cart:updated'].forEach(function (ev) { document.addEventListener(ev, scheduleCartCheck); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', checkCart);
  else checkCart();
  var drawerObserver = new MutationObserver(function () {
    if (!badItems.length) return;
    var pending = Array.prototype.some.call(checkoutButtons(), function (b) { return !b.getAttribute('data-te-blocked'); });
    if (pending) renderBanner();
  });
  document.addEventListener('DOMContentLoaded', function () {
    var drawer = document.querySelector('cart-drawer, #CartDrawer, .cart-drawer');
    if (drawer) drawerObserver.observe(drawer, { childList: true, subtree: true });
  });
})();
